/**
 * The username a password manager keys a credential on, for a form that asks
 * for a password without asking who you are.
 *
 * Chromium's own guidance ("Create Amazing Password Forms"): *"the username
 * field in a change password form … is still useful to password managers
 * (there may be multiple accounts associated with a web site, for example), so
 * include a hidden input field containing this information even if it is not
 * directly necessary for your form."* Without one, Chrome logs *"Password
 * forms should have (optionally hidden) username fields for accessibility"* —
 * F1 of `qa-alpha-2026-08-17` — and a manager saves the new password against
 * the wrong account, or offers nothing at all.
 *
 * `hidden` rather than a visually-hidden class: an input with no label that a
 * screen reader can still reach is an axe `label` violation, and `hidden`
 * takes it out of the accessibility tree instead. `type="text"`, never
 * `type="hidden"` — managers skip that type. `readOnly` because the value is
 * the session's, not something to type into.
 *
 * A form that does not know whose account it is must not render this: a guessed
 * value is worse than none. See the comment in `ResetPassword.jsx`.
 */
export default function HiddenUsername({ username }) {
  return (
    <input
      type="text"
      name="username"
      autoComplete="username"
      value={username}
      readOnly
      hidden
      tabIndex={-1}
    />
  )
}
